import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    totalNotiUnread: 0
}

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        setTotalNotiUnread: (state, action) => {
            state.totalNotiUnread = action.payload;
        }
    }
})

export default notificationSlice.reducer
export const { setTotalNotiUnread } = notificationSlice.actions